import { render } from "./StackPropertiesCell.vue?vue&type=template&id=4b8476d0"
import script from "./StackPropertiesCell.vue?vue&type=script&lang=js"
export * from "./StackPropertiesCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__